import * as React from 'react';
import Box from '@mui/material/Box';
import { GridTable } from '../../Sidebar/SidebarStyles';
import ReportTable from '../ReportTable';
import { fetchAutoJobLOBMappingReport, generateExportAutoJobLOBMappingReport } from '../../ApiSevices/ReportApis';
import ReportFilterForm from '../ReportFilterForm';
import { Alert, Button, Snackbar } from '@mui/material';

interface TableProps {
    displaysidebar: boolean;
}
interface State {
    loading: boolean;
    AutoLOBData: any[];
    page: number;
    rowsPerPage: number;
    totalCount: number;
    AutoLOBJobInput: AutoLOBInput;
    snackbarOpen: boolean;
    snackbarMessage: any;
}
interface AutoLOBInput {
    page: number;
    rowsPerPage: number;
}
class AutoJobLOBMappingReport extends React.Component<TableProps, State> {
    constructor(props: TableProps) {
        super(props);
        this.state = {
            loading: false,
            AutoLOBData: [],
            page: 0,
            rowsPerPage: 100,
            totalCount: 0,
            AutoLOBJobInput: {
                page: 0,
                rowsPerPage: 100,
            },
            snackbarOpen: false,
            snackbarMessage: '',
        };
    }

    componentDidMount() {
        this.handleFilter();
    }

    fetchData = async (page: number, rowsPerPage: number) => {
        this.setState({ loading: true });
        try {
            const res = await fetchAutoJobLOBMappingReport(page, rowsPerPage,);
            if (res?.data?.length > 0) {
                this.setState({
                    AutoLOBData: res.data || [],
                    totalCount: res.totalCount || 0,
                    page,
                    rowsPerPage
                });
            }
            else {
                this.setState({ AutoLOBData: [] });
                this.showSnackbar('No data available for the selected inputs.', 'error');
            }
        } catch (error) {
            console.error('Error fetching report data:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleFilter = () => {
        const { page, rowsPerPage } = this.state.AutoLOBJobInput;
        this.fetchData(page, rowsPerPage);
    };

    handleFilterSubmit = () => {

    }

    handleExportExcel = async () => {
        this.setState({ loading: true });
        try {
            const fileBlob = await generateExportAutoJobLOBMappingReport();

            const url = window.URL.createObjectURL(fileBlob);
            const link = document.createElement('a');
            link.href = url;

            const filename = `AutoJobLOBMapping_Report_${new Date().toISOString().replace(/[:.]/g, '')}.xlsx`;
            link.setAttribute('download', filename);

            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting Auto Job LOB Mapping Report:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handlePageChange = (event: unknown, newPage: number) => {
        const { rowsPerPage, } = this.state;
        this.fetchData(newPage, rowsPerPage);
    };

    handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        this.fetchData(0, newRowsPerPage);
    };

    showSnackbar = (message: string, severity: 'error') => {
        this.setState({ snackbarOpen: true, snackbarMessage: message });
    };

    handleCloseSnackbar = () => {
        this.setState({ snackbarOpen: false });
    };

    
    render() {
        const { loading, AutoLOBData, totalCount, page, rowsPerPage, snackbarOpen, snackbarMessage } = this.state;
        const { displaysidebar } = this?.props;

        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}

                <GridTable displaysidebar={displaysidebar}>
                    <>
                        <Box
                            sx={{
                                padding: '2px 0',
                                backgroundColor: '#f8f8f8',
                                borderBottom: '1px solid #ddd',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    color: '#000',
                                    marginLeft: '8px',
                                    textTransform: 'uppercase',
                                }}
                            >
                                AUTO JOB LOB MAPPING REPORT
                            </span>
                        </Box>
                        
                        <br/>
                        <Button size='small' color='primary' variant="contained" onClick={this.handleExportExcel}>Export as Excel</Button>
                        <br/>
                        <br/>
                        {/* <ReportFilterForm onSubmit={this.handleFilterSubmit} onExport={this.handleExportExcel} showBroker={false} showStatus={false} showFromDate={false} showToDate={false} showGenerteBtn={false} showExcelBtn={true} showSubmitBtn={false} showJobid={false} /> */}
                        <Box sx={{ overflow: 'hidden', height: '100%', width: '100%' }}>
                            <ReportTable
                                data={AutoLOBData}
                                totalCount={totalCount}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                onPageChange={this.handlePageChange}
                                onRowsPerPageChange={this.handleRowsPerPageChange}
                            />
                        </Box>
                        <Snackbar
                            open={snackbarOpen}
                            autoHideDuration={1500}
                            onClose={() => this.setState({ snackbarOpen: false })}
                            anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        >
                            <Alert onClose={() => this.setState({ snackbarOpen: false })} severity="error" sx={{ width: "100%" }}>
                                {snackbarMessage}
                            </Alert>
                        </Snackbar>

                    </>
                </GridTable>

            </>
        );
    }
}

export default AutoJobLOBMappingReport;